/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const deleteCollectionSubtitleResponseSchema = createApiResponseSchema();

export type IDeleteCollectionSubtitleResponse = IAPI;
